import { render, staticRenderFns } from "./HousesModuleComponent.vue?vue&type=template&id=ee374e1c&scoped=true"
import script from "./HousesModuleComponent.vue?vue&type=script&lang=js"
export * from "./HousesModuleComponent.vue?vue&type=script&lang=js"
import style0 from "./HousesModuleComponent.vue?vue&type=style&index=0&id=ee374e1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee374e1c",
  null
  
)

export default component.exports